import { render, staticRenderFns } from "./SelectArtiesDialog.vue?vue&type=template&id=3990e86a&scoped=true&"
import script from "./SelectArtiesDialog.vue?vue&type=script&lang=js&"
export * from "./SelectArtiesDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectArtiesDialog.vue?vue&type=style&index=0&id=3990e86a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990e86a",
  null
  
)

export default component.exports